

export const EDITOR_TOOLBAR = [
  {
    name: "clipboard",
    groups: [
      "Cut",
      "Copy",
      "Paste",
      "PasteText",
      "PasteFromWord",
      "-",
      "Undo",
      "Redo",
    ],
  },
  {
    name: "basicStyles",
    groups: [
      "Bold",
      "Italic",
      "Underline",
      "Strike",
      "Subscript",
      "Superscript",
    ],
  },
  {
    name: "paragraph",
    groups: ["NumberedList", "BulletedList", "Outdent", "Indent", "Blockquote"],
  },
  {
    name: "alignment",
    groups: [
      "JustifyLeft",
      "JustifyCenter",
      "JustifyRight",
      "JustifyBlock",
      "BidiLtr",
      "BidiRtl",
    ],
  },
  { name: "links", groups: ["Link", "Unlink", "Image"] },
  { name: "table", groups: ["Table", "TableToolbar"] },
  {
    name: "styles",
    groups: ["Font", "FontSize", "Format", "TextColor", "BGColor"],
  },
  { name: "miscellaneous", groups: ["Find", "Replace", "Source"] },
  { name: "insert", groups: ["cstButton2"] },
];
export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const SWAL_SETTINGS = {
  customClass: "swal-wide",
  position: "top-right",
  showConfirmButton: false,
  timer: 7000,
  toast: true,
  showClass: {
    popup: "animate__animated animate__bounceInRight",
  },
  hideClass: {
    popup: "animate__animated animate__bounceOutRight",
  },
  showCloseButton: true,
  // timerProgressBar: true,
};
export const showFilterlist = [
  { name: "admin.filter_placeholder.heading_status", status__id: "" },
  { name: "admin.button.btn_active", status__id: "1" },
  { name: "admin.button.btn_inactive", status__id: "0" },
];

export const showFilterlistNew = [
  { name: "admin.filter_placeholder.heading_status", status__id: "" },
  { name: "Available", status__id: "1" },
  { name: "Unavailable", status__id: "0" },
];
export const showFilterlistCms = [
  { name: "admin.filter_placeholder.heading_status", status__id: "" },
  { name: "admin.button.btn_active_button", status__id: "1" },
  { name: "admin.button.btn_inactive_button", status__id: "0" },
];
export const showFilterListAppointment = [
  { name: "admin.filter_placeholder.heading_status", value: "" },
  { name: "Completed", value: "completed" },
  { name: "Pending", value: "pending" },
];
export const ROLE = {
  SUPER_ADMIN: "super_admin",
  CENTER : "center",
  DOCTOR : "doctor"
};

export const EMAIL_TEMPLATE_TYPES = {
  DEFAULT: "default",
};

export const TRANSACTION_STATUS = {
  PENDING: "pending",
  SUCCESS: "success",
  FAILED: "failed",
};

export const TRANSACTION_TYPES = {
  PAYMENT: "payment",
  REFUND: "refund",
};

export const DEFAULT_EMAIL_OPTIONS = [
  "web_url",
  "name",
  "title",
  "first_name",
  "middle_name",
  "last_name",
  "email",
  "role",
  "phone_number"
];

export const DYNAMIC_VARIABLES = {
  SERVER_URL: process.env.REACT_APP_API_URL.replace("/webservice/api/v1", ""),
};

export const OTP_LENGTH = 6;
export const NUMBER_CHARACTER_ONLY = /^\d+$/;
export const MOBILE_NUMBER_REGEX = /^[0-9]+$/;
// export const EMAIL_REGEX = /^[a-zA-Z0-9._'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._'-]{1,100}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,20}$/;
export const ATLEAST_ONE_SMALL_REGEX = /[a-z]/g;
export const ATLEAST_ONE_CAPITAL_REGEX = /[A-Z]/g;
export const ATLEAST_ONE_NUMBER_REGEX = /[0-9]/g;
export const ATLEAST_ONE_SPECIAL_CHARACTER_REGEX = /[^\w\s]/;
export const URL_REGEX = /^(ftp|http|https):\/\/[^ "]+$/;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 20;
export const INPUT_LENGTH_15 = 15
export const INPUT_MAX_25 = 25;
export const INPUT_LENGTH_50 = 50;
export const INPUT_LENGTH_100 = 100;
export const INPUT_LENGTH_500 = 500;
export const TEXTAREA_MAX_LENGTH = 150;
export const INPUT_MAX_50 = 50;
export const CKEDITOR_CONFIG = {
  filebrowserUploadUrl: `${process.env.REACT_APP_API_URL}/common/upload-ck-image`,
  allowedContent: true,
  fileTools_requestHeaders: {
    Authorization: `Bearer ${localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).token : ""}`,
  },
  extraAllowedContent: '*[*]',
  toolbar: [
    { name: 'source', items: ['Source'] },
    { name: 'functions', items: ['NewPage', 'ExportPdf', 'Print', 'Preview',] },
    { name: 'clipboard', items: ["Cut", "Copy", "Paste", "CopyFormatting"] },
    { name: 'miscellaneous', items: ["Undo", "Redo"] },
    { name: 'text-corrections', items: ['Find', 'Replace', 'SelectAll', 'Scayt'] },
    { name: 'basic-styles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
    { name: 'paragraph', items: ['NumberedList', 'BulletedList', 'Outdent', 'Indent', 'Blockquote'] },
    { name: 'alignment', items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'BidiLtr', 'BidiRtl'] },
    { name: 'links', items: ['Link', 'Unlink', 'Anchor', 'Image'] },
    { name: 'table', items: ['Table', 'TableToolbar'] },
    { name: 'styles', items: ['Font', 'FontSize', 'Format', 'TextColor', 'BGColor', 'PageBreak'] },
    { name: 'forms', items: ['Form', "Radio", "Checkbox", "TextField", "Textarea", "Select", 'MediaButton'] },
    { name: 'configs', items: ['Smiley', 'SpecialChar', 'Iframe', 'Maximize'] }
  ]
};

export const COOKIES_EXPIRATION = 7; /** In Days */
export const MAX_VOICE_MEMO_SECONDS = 30; /** In Seconds */
export const FILE_UPLOAD = {
  CHUNK_SIZE: 1048576 /** 1 MB */,
};

export const PHONE_NO_LENGTH = {
  min: 7,
  max: 10
};

export const MENU_LOCATION = {
 menu_of_page_header: "header",
 menu_of_page_footer: "footer",
};

export const FOOTER_LOCATION = {
  company_location_of_page_footer: "company",
  legal_location_of_page_footer: "legal",
};

export const amountRegex = /^\d{1,9}(\.\d{1,2})?$/;
export const phoneRegExp = /^(\+?\d{1,4}[\s-]?)?(?!0+\s+,?$)\d{10,14}$/;

export const cuisineOptions = [
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Indian', value: 'Indian' },
  { label: 'Nepali', value: 'Nepali' },
  { label: 'Chinese', value: 'Chinese' },
  { label: 'Korean', value: 'Korean' },
  { label: 'Indonesian', value: 'Indonesian' },
  { label: 'Thai', value: 'Thai' },
  { label: 'Vietnamese', value: 'Vietnamese' },
  { label: 'Malaysian', value: 'Malaysian' },
  { label: 'Philippine', value: 'Philippine' },
  { label: 'Bruneian', value: 'Bruneian' },

];

export const PLAN_TYPES = {
  DEMO: "demo",
  PREMIUM_PLAN: "premium_plan"
};
export const PLAN_DURATION_TYPES = {
  MONTHLY: "monthly",
  YEARLY: "yearly"
};

export const SOCKET_EVENTS = {
  STAFF_PASSWORD_CHANGED:"staff_password_changed",
  RESTAURANT_DETAILS_CHANGED:"restaurant_details_changed",
  ORDER_PLACED:"order_placed",
  ORDER_BILLED:"order_billed"
};

export const LOADER_TIMEOUT_TIME = 500; /* TIME FOR LOADER   */

export const ACTIVE = 1;
export const DEACTIVE = 0;

export const CENTER_LOGIN_ERROR_TYPES = {
  INVALID_CREDENTIALS: "invalid_credentials",
  ACCOUNT_IS_BLOCKED: "account_is_blocked",
  ACCOUNT_NOT_ENROLLED: "account_not_enrolled",
  SUBSCRIPTION_EXPIRED: "subscription_expired",
  PASSWORD_NOT_SET_YET: "password_not_set_yet",
};

export const DOCTOR_LOGIN_ERROR_TYPES = {
  INVALID_CREDENTIALS: "invalid_credentials",
  ACCOUNT_IS_BLOCKED: "account_is_blocked",
  ACCOUNT_NOT_ENROLLED: "account_not_enrolled",
  SUBSCRIPTION_EXPIRED: "subscription_expired",
  PASSWORD_NOT_SET_YET: "password_not_set_yet",
};

export const USER_ENQUIRY_TYPES = {
  SIMPLE_INQUIRY: "simple_inquiry",
  NEED_SUPPORT: "need_support"
};


export const ITEM_TYPES = {
  ITEM: "item",
  SET_OF_ITEMS: "set_of_items"
};
export const ITEM_TAX_OPTIONS = {
  INCLUSIVE: "inclusive",
  EXCLUSIVE: "exclusive"
};

export const RECEIPT_TYPES = {
  TYPE_1: "receipt_style_1",
  TYPE_2: "receipt_style_2",
  TYPE_3: "receipt_style_3"
}


export const TAX_ROUND_OFF_FRACTIONS = {
  TRUNCATE: "truncate",
  ROUND_UP: "round_up",
  ROUND_OFF: "round_off"
};

export const DISPLAY_METHOD_TAX_OPTIONS = {
  TAX_INCLUDED: "tax_included",
  TAX_EXCLUDED: "tax_excluded"
}

export const PAYMENT_METHOD_TYPES = {
  CREDIT_CARD: "credit_card",
  QR_PAYMENTS: "qr_payments",
};

export const CATEGORIES_TAX_TYPES = [
  { label: 'constant.label_dine_option', value: 'dine' },
  { label: 'constant.label_take_out_option', value: 'take_out' }
];

export const TABLE_SHAPE_TYPES = [
  { label: 'label_round', value: 'round' },
  { label: 'label_square', value: 'square' } , 
  { label: 'label_rectangle', value: 'rectangle' }
];

export const NOTES = [
  { value: 10000, label: '¥10000' },
  { value: 5000, label: '¥5000' },
  { value: 2000, label: '¥2000' },
  { value: 1000, label: '¥1000' },
];


export const COINS = [
  { value: 500, label: '¥500' },
  { value: 100, label: '¥100' },
  { value: 50, label: '¥50' },
  { value: 10, label: '¥10' },
  { value: 5, label: '¥5' },
  { value: 1, label: '¥1' }]

export const QR_CODE_TYPES={
  TABLE:'table'
}
export const SPICE_LEVELS={
  LOW:'low',
  MEDIUM:'medium',
  HIGHT:'high',
};


export const CUSTOMER_TAGS = {
  VIP : 'vip' ,
  REGULAR : 'regular'
};

export const ORDER_TYPES = {
  BASE_ORDER : "base_order" , 
  SUB_ORDER : "sub_order"
};

export const ORDER_STATUS = {
  PENDING : "pending" , 
  CHECKED_OUT : "checked_out" , 
  BILLED : "billed"
};
export const TITLE_MAX_LIMIT = 500 ;

export const SERVICE_CHARGED_CONDITION = {
  ALWAYS : 'always' , 
  AT_CHECKOUT : 'at_checkout'
}

export const DEFAULT_ITEM_LANGUAGE='ja';


export const ORDER_PLATFORM = {
  WEB : "web" , 
  APP : "waiter-app"
}

export const RESERVATION_STATUS = [
  { label: 'label_upcoming', value: 'reserved' },
  { label: 'label_cancelled', value: 'cancelled' } , 
  { label: 'label_passed', value: 'passed' }
]


export const SORT_A = 1;
export const SORT_D = -1;

export const COUPON_TYPES = {
  FLAT: "flat",
  PERCENTAGE: "percentage"
};


export const COUPON_CATEGORY_TYPES = [
  { label: 'label_general', value: 'general' },
  { label: 'label_special', value: 'special' },
];

export const FILE_SLUG = {
  CATEGORY : "category" , 
  MENU_ITEMS : "menu_items" , 
  OPTIONS : "options"

}

export const APPOINTMENT_STATUS_NEW = {
  SCHEDULE : "scheduled" , 
  COMPLETE : "completed" , 
  CANCEL :   "canceled"
}

export const PAYMENT_METHOD_TYPES_TRANSACTION = [
  { label: 'label_cash', value: 'cash' },
  { label: 'label_card', value: 'card' },
  { label: 'label_other', value: 'other' },
]


export const REPORT_TAX_TYPES = [
  { label: 'label_with_tax', value: 'With Tax' },
  { label: 'label_without_tax', value: 'Without Tax' },
];


export const FULLMONTHS = [
  "label_Jan",
  "label_Feb",
  "label_Mar",
  "label_Apr",
  "label_May",
  "label_Jun",
  "label_Jul",
  "label_Aug",
  "label_Sep",
  "label_Oct",
  "label_Nov",
  "label_Dec",
];
export const DAYNAMES=  ['label_sunday', 'label_monday', 'label_tuesday','label_wednesday','label_thursday','label_friday','label_saturday'];
export const COUPON_MAX_FLAT_DISCOUNT=  100000000;
export const COUPON_CODE_MAX_LENGTH=  100;

export const CONSUMPTION_TAX_RATES = {
  DINE:10,
  TAKE_OUT:8, 
};
export const GENDER = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
];
export const VIDEO_CATEGORY = [
  { label: 'Exercise', value: 'exercise' },
  { label: 'Pregnancy', value: 'pregnancy' },
  { label: 'Post Surgery Care', value: 'post_surgery_care' },
];
export const SUGAR_TYPE = [
  { label: 'White Sugar', value: 'white_sugar' },
  { label: 'Brown Sugar', value: 'brown_sugar' },
];
export const DOCTOR_SPECIALIZATION = [
  { label: 'Cardiology', value: 'cardiology' },
  { label: 'Dermatology', value: 'dermatology' },
  { label: 'Neurology', value: 'neurology' },
  { label: 'Pediatrics', value: 'pediatrics' },
  { label: 'Orthopedics', value: 'orthopedics' },
];

export const APPOINTMENT_STATUS = [
  { label: 'Schedule', value: 'scheduled' },
  { label: 'Complete', value: 'completed' },
  { label: 'Cancel', value: 'canceled' },
];

export const ALL_APPOINTMENT_STATUS = [
  { label: 'Scheduled', value: 'scheduled' },
  { label: 'Completed', value: 'completed' },
  { label: 'Cancelled', value: 'canceled' },
];

export const SLEEP_PATTERN = [
  { label: 'Sound Sleep ', value: 'sound_sleep' },
  { label: 'Disturb Sleep', value: 'disturb_sleep' },
  { label: 'Intermittent Sleep', value: 'intermittent_sleep' },
];

// export const NOTIFICATION_INTERVAL = [2,3,4,5,6,7,8,9,10,11,12]


export const NOTIFICATION_INTERVAL = Array.from({ length: 96 }, (_, i) => {
  const hours = Math.floor(i / 4);
  const minutes = Math.floor(i%4) === 0 
    ? "00" 
    : (
        Math.floor(i%4) === 1
        ? "15"
        : (
            Math.floor(i%4) === 2
            ? "30"
            : "45"
          )
      )
  console.log('-------mins', minutes, '--------i', i);
  const label = `${hours < 10 ? "0" : ""}${hours}:${minutes}`;
  return { label, value: label };
});


export const decideStatus = (status) => {
  if (status === APPOINTMENT_STATUS_NEW.SCHEDULE) {
    return <span className="">Scheduled</span>
  } else if (status === APPOINTMENT_STATUS_NEW.COMPLETE) {
    return <span className="">Completed</span>
  } else if (status === APPOINTMENT_STATUS_NEW.CANCEL) {
    return <span className="">Cancelled</span>
  }
  else{
    return <span className="">Unknown</span>
  }
}

export const WORKOUT_CATEGORY = [
  { label: 'Cardio', value: 'cardio' },
  { label: 'Weight Training', value: 'weight_training' },
  { label: 'Yoga', value: 'yoga' },
  { label: 'Zumba', value: 'zumba' },
  { label: 'Walking', value: 'walking' },
  { label: 'Cycling', value: 'cycling' },
  { label: 'Swimming', value: 'swimming' },
  { label: 'Jogging', value: 'jogging' },
  { label: 'Meditation', value: 'meditation' },
];
export const WORKOUT_PLAN = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
  { label: 'Monthly', value: 'monthly' },
];
export const APPOINTMENT_ZONE = [
  { label: 'Center', value: 'center' },
  { label: 'Doctor', value: 'doctor' },
  { label: 'Online application', value: 'online' },
  { label: 'Customer care', value: 'customer_care' },
];

export const APPOINTMENT_ZONE_DOCTOR = [
  { label: 'Center', value: 'center' },
  { label: 'Online application', value: 'online' },
  { label: 'Customer care', value: 'customer_care' },
];

export const MEDICAL_CONDITIONS = [
  { label: 'Diabetes', value: 'diabetes' },
  { label: 'Hypothyroidism', value: 'hypothyroidism' },
  { label: 'Hyperthyroidism', value: 'hyperthyroidism' },
  { label: 'PCOS', value: 'pcos' },
  { label: 'BP', value: 'bp' },
  { label: 'Coronary Artery Disease', value: 'coronary_artery_disease' },
  { label: 'Gastric Issues', value: 'gastric_issues' },
  { label: 'Fatty Liver', value: 'fatty_liver' },
  { label: 'Osteoarthritis', value: 'osteoarthritis' },
  { label: 'Rheumatoid Arthritis', value: 'rheumatoid_arthritis' },
  { label: 'Chronic Kidney Disease', value: 'chronic_kidney_disease' },
  { label: 'Renal Stone', value: 'renal_stone' },
  { label: 'Obesity', value: 'obesity' },
  { label: 'Migraine', value: 'migraine' },
  { label: 'Depression', value: 'depression' },
  { label: 'Anxiety', value: 'anxiety' },
  { label: 'Respiratory Disorders', value: 'respiratory_disorders' },
  { label: "Other", value: "other" },
];

export const ALLERGIES = [
  { label: 'Peanut', value: 'peanut' },
  { label: "Cow's Milk", value: 'cows_milk' },
  { label: 'Egg', value: 'egg' },
  { label: 'Fish', value: 'fish' },
  { label: 'Soy', value: 'soy' },
  { label: 'Wheat', value: 'wheat' },
  { label: 'Gluten', value: 'gluten' },
  { label: 'Lactose', value: 'lactose' },
  { label: 'Pulses', value: 'pulses' },
  { label: "Other", value: "other" },
];

export const MEAL_TIMES = [
  { label: 'Early Morning', value: 'early_morning' },
  { label: 'Breakfast', value: 'breakfast' },
  { label: 'Mid Morning', value: 'mid_morning' },
  { label: 'Lunch', value: 'lunch' },
  { label: 'Evening Snacks', value: 'evening_snacks' },
  { label: 'Dinner', value: 'dinner' },
];

export const DIET_CHART_MAPPING = {
  early_morning : 'Early-Morning',
  breakfast : 'Breakfast',
  mid_morning : 'Mid-Morning Snack',
  lunch : 'Lunch',
  evening_snacks : 'Evening Snack',
  dinner : 'Dinner',
}

// export const ACTIVITY_LEVEL = [
//   { label: 'Sedentary', value: 'sedentary' },
//   { label: 'Lightly Active', value: 'lightly_active' },
//   { label: 'Moderately Active', value: 'moderately_active' },
//   { label: 'Active', value: 'active' },
//   { label: 'Very Active', value: 'very_active' },
// ];

export const ACTIVITY_LEVEL = [
  { label: "Sedentary (little or no exercise)", value: "sedentary", multiplier: 1.2 },
  { label: "Lightly active (light exercise 1–3 days/week)", value: "lightly_active", multiplier: 1.375 },
  { label: "Moderately active (moderate exercise 3–5 days/week)", value: "moderately_active", multiplier: 1.55 },
  { label: "Very active (hard exercise 6–7 days/week)", value: "very_active", multiplier: 1.725 },
  { label: "Super active (twice/day training, physical job)", value: "super_active", multiplier: 1.9 },
];

export const SLEEP_QUALITY = [
  { label: 'Poor', value: 'poor' },
  { label: 'Fair', value: 'fair' },
  { label: 'Good', value: 'good' },
  { label: 'Very Good', value: 'very_good' },
  { label: 'Excellent', value: 'excellent' },
];

export const DRINKING_HABITS = [
  { label: 'Daily', value: 'daily' },
  { label: 'Frequently (3 times in a week)', value: 'frequently' },
  { label: 'Occasionally (Once in 15 days)', value: 'occasionally' },
  { label: 'None', value: 'none' },
];

export const SMOKING_HABITS = [
  { label: 'Light Smokers (1–10 cigarettes/day)', value: 'light' },
  { label: 'Moderate Smokers (11–20 cigarettes/day)', value: 'moderate' },
  { label: 'Heavy Smokers (more than 20 cigarettes/day)', value: 'heavy' },
  { label: 'Occasional (less than 1 cigarette/day)', value: 'occasional' },
  { label: 'None', value: 'none' },
];

export const DIET_TYPE = [
  { label: 'Vegetarian', value: 'veg' },
  { label: 'Non-Vegetarian', value: 'non_veg' },
  { label: 'Vegan', value: 'vegan' },
  { label: 'Jain', value: 'jain' },
  { label: 'Gluten-Free', value: 'gluten_free' },
];

export const CUISINE_PREFERENCE = [
  { label: 'North Indian Cuisine', value: 'north_indian' },
  { label: 'South Indian Cuisine', value: 'south_indian' },
  { label: 'Punjabi', value: 'punjabi' },
  { label: 'Kashmiri', value: 'kashmiri' },
  { label: 'Rajasthani', value: 'rajasthani' },
  { label: 'Bengali', value: 'bengali' },
  { label: 'Assamese', value: 'assamese' },
  { label: 'Odia', value: 'odia' },
  { label: 'Gujarati', value: 'gujarati' },
  { label: 'Maharashtrian', value: 'maharashtrian' },
  { label: 'North-East Indian Cuisine', value: 'north_east_indian' },
];

export const CRAVING_FOODS = [
  { label: 'Sweets', value: 'sweets' },
  { label: 'Fried', value: 'fried' },
  { label: 'Fatty', value: 'fatty' },
  { label: 'Salty', value: 'salty' },
  { label: 'Crunchy', value: 'crunchy' },
  { label: 'Caffeinated', value: 'caffeinated' },
  { label: 'Carb Heavy', value: 'carb_heavy' },
  { label: 'Chocolate', value: 'chocolate' },
  { label: 'Spicy', value: 'spicy' },
  { label: 'Sour', value: 'sour' },
  { label: 'Meaty', value: 'meaty' },
];

export const HEALTH_FITNESS_GOALS = [
  { label: 'Lose weight', value: 'lose_weight' },
  { label: 'Gain muscle', value: 'gain_muscle' },
  { label: 'Control sugar/BP', value: 'control_sugar_bp' },
  { label: 'Improve digestion', value: 'improve_digestion' },
  { label: 'Maintain health', value: 'maintain_health' },
  { label: 'Fat lose', value: 'fat_lose' },
];

export const SOURCE_OF_CALL = [
  { label: 'TV', value: 'tv' },
  { label: 'Social media', value: 'social_media' },
  { label: 'Camp', value: 'camp' },
  { label: 'Other', value: 'other' },
];



export const MEDICINE_OPTIONS = [
  {label: 'Before Meal', value: 'before_meal'},
  {label: 'After Meal', value: 'after_meal'},
  {label: 'Hot Water', value: 'hot_water'},
  {label: 'Normal Water', value: 'normal_water'},
  {label: 'Empty Stomach', value: 'empty_stomach'},
  {label: 'With Milk', value: 'with_milk'},
]





